import axios from 'axios';

class MitSettingsService {
  constructor() {}
  
  getMerakiSettings() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/management/settings/meraki')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  get() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/management/settings/admin')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  save(settings) {
    return new Promise ((resolve, reject) => {

      axios.put('/api/v1/management/settings/admin', settings)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

}

export default new MitSettingsService();
